export const ANALYTICS_CONSENT_STORAGE_KEY = 'calensync-analytics-consent';

export function hasAnalyticsConsent(): boolean {
    try {
        return localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY) === 'yes';
    } catch {
        return false;
    }
}

export function grantAnalyticsConsent(): void {
    if (typeof window === 'undefined' || !window.gtag) {
        return;
    }
    window.gtag('consent', 'update', { analytics_storage: 'granted' });
}
